import { render, staticRenderFns } from "./edit-user.vue?vue&type=template&id=08234e5e&scoped=true&"
import script from "./edit-user.vue?vue&type=script&lang=js&"
export * from "./edit-user.vue?vue&type=script&lang=js&"
import style0 from "./edit-user.vue?vue&type=style&index=0&id=08234e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08234e5e",
  null
  
)

export default component.exports